import { useDispatch } from "react-redux"
import { CToast } from "../../../views/addons/ToastMessage"
import { masterDictionary } from "./dictionaries"
import { setErrors } from "../../../redux/actions/validator"

export const useErrorHandler = (endPoint, showToasts = true) => {
    const dispatch = useDispatch()

    const errorHandler = (errorList) => {
        const errorMap = new Map()
        errorList.forEach(element => {
            const [id, ...rest] = element.split('¬')
            if (!errorMap.has(id)) errorMap.set(id, [])
            errorMap.get(id).push(rest.join(' '))
        })

        const spreatedErrorMap = [...errorMap.keys()]
        dispatch(setErrors(spreatedErrorMap))

        if (!showToasts) {
            spreatedErrorMap.forEach(a => {
                console.log(a)

                const msg = errorMap.get(a).filter(e => e.length > 0).map((e, i) => <li key={`errorMap_${i}`}>{e}</li>)
                CToast({ title: getTitleFrom(a.split('.')[a.split('.').length - 1]), message: <ul>{msg}</ul> })
            })
        }
    }

    const getTitleFrom = (key) => masterDictionary[endPoint][key]

    return { errorHandler }
}
